import MisleadingAdvertisingClaims from './MisleadingAdvertisingClaims'
import TeensAndSocialMedia from './TeensAndSocialMedia'
import LetsReview from './LetsReview'
import Resources from './Resources'
import Question1 from './Question1'
import Question2 from './Question2'
import Question3 from './Question3'
import Question4 from './Question4'

export default {
  title: 'Learn',
  children: [
    LetsReview,
    MisleadingAdvertisingClaims,
    TeensAndSocialMedia,
    Resources,
    Question1,
    Question2,
    Question3,
    Question4,
  ],
}



// WEBPACK FOOTER //
// ./src/data/Learn/index.js